<template>
  <div class="manager">
    <div class="manager__header">
      <h3>Manager Menu</h3>
      <base-button-1 class="manager__button--close" @click="$emit('update:isManager', false)">
        Zamknij <i class="fas fa-times"></i>
      </base-button-1>
    </div>
    <div class="eventRow">
      <h3 class="eventRow__name">{{ competition.name }}</h3>
      <div class="eventRow__row">
        <div class="eventRow__time"><span>Początek:</span>
          <span>{{ competition.startedTime.format('YYYY-MM-DD HH:mm:ss') }}</span>
        </div>
        <div v-if="eventTimesData.end_event" class="eventRow__time"><span>Koniec:</span>
          <span>{{ eventTimesData.end_event }}</span>
        </div>
        <base-button-1 v-else :disabled="eventTimesData.end_event" class="manager__button manager__button--endEvent"
          @click="endEvent">
          <i class="fas fa-flag-checkered"></i>
          Koniec eventu
          <i class="fas fa-flag-checkered"></i>
        </base-button-1>
      </div>
    </div>
    <div class="eventRow">
      <h5 class="eventRow__name">Klasyfikacja:<base-input-select :clearable="false"
          class="manager__classifications--eventRow" :value="selectedClassification" @input="
            SET_SELECTED_CLASSIFICATION_ID($event.id),
            eventBus.$emit('selectedClassification')
            " :options="classifications" label="namePl" /></h5>
      <div class="eventRow__row">
        <div v-if="seriesStartTime" class="eventRow__time"><span>Rozpoczęcie:</span>
          <span>{{ seriesStartTime }}</span>
        </div>
        <base-button-1 v-else :disabled="seriesStartTime" class="manager__button manager__button--startEvent"
          @click="setClassificationTime('start_event')">
          <i class="fas fa-stopwatch"></i>
          Rozpocznij klasyfikację
        </base-button-1>
        <div v-if="seriesEndTime" class="eventRow__time"><span>Zakończenie:</span>
          <span>{{ seriesEndTime }}</span>
        </div>
        <base-button-1 v-else :disabled="eventTimesData.end_event" class="manager__button manager__button--endEvent"
          @click="setClassificationTime('end_event')">
          Zakończ klasyfikacje
          <i class="fas fa-flag-checkered"></i>
        </base-button-1>
      </div>
    </div>
    <div class="manager__body">
      <div class="series">
        <div class="series__row">
          <div class="row__content" v-for="(serie, index) in editableSeries" :key="index"
            :class="{ 'row__content--error': errors[serie.number] }">
            <h5 class="series__label">Seria #{{ serie.number }}</h5>
            <div class="series__cell">
              <base-button-1 :disabled="!!serie.series_start" class="series__button series__button--start"
                @click="isLoading ? null : setFieldTime(index, 'series_start')">
                Start <i class="fas" :class="!isLoading ? 'fa-stopwatch' : 'fa-spin fa-spinner'"></i>
              </base-button-1>
              <BaseInputMask :disabled="serie.series_start === null || isLoading" v-model.lazy="serie.series_start"
                mask="0000-00-00 00:00:00" placeholder="RRRR-MM-DD GG:MM:SS" class="timeInput"
                :class="{ 'timeInput--error': serie.error }"
                @complete="val => setFieldTime(index, 'series_start', val)" />
            </div>
            <div class="series__cell">
              <base-button-1 :disabled="!!serie.series_end || !serie.series_start || isLoading"
                class="series__button series__button--meta"
                @click="isLoading ? null : setFieldTime(index, 'series_end')">
                Meta <i class="fas" :class="!isLoading ? 'fa-flag-checkered' : 'fa-spin fa-spinner'"></i>
              </base-button-1>
              <BaseInputMask :disabled="serie.series_end === null || isLoading" v-model.lazy="serie.series_end"
                mask="0000-00-00 00:00:00" placeholder="RRRR-MM-DD GG:MM:SS" class="timeInput"
                @complete="val => setFieldTime(index, 'series_end', val)" />
            </div>
          </div>
        </div>
        <div class="series__row">
          <div class="series__cell">
            <base-button-1 class="series__button series__button--add" @click="isLoading ? null : addRow()">
              Dodaj serie <i class="fas" :class="!isLoading ? 'fa-plus' : 'fa-spin fa-spinner'"></i>
            </base-button-1>
          </div>
        </div>
      </div>
    </div>
    <div class="manager__footer">
      <base-button-1 class="manager__button--close-ftr" @click="$emit('update:isManager', false)">
        Zamknij <i class="fas fa-times"></i>
      </base-button-1>
    </div>
  </div>
</template>

<script>
import BaseButton1 from '@/components/BaseButton1'
import BaseInputSelect from '@/components/BaseInputSelect'
import BaseInputMask from './BaseInputMask.vue'
import { mapGetters, mapMutations } from 'vuex'
import _ from 'lodash'
import {
  SET_SELECTED_CLASSIFICATION_ID
} from '@/store/mutations.type'
import { eventBus } from '@/main'
import moment from 'moment'
import { apiAP } from '@/api'
import { READ_EVENT_TIMES_DATA } from '@/store/actions.type'

export default {
  components: {
    BaseButton1,
    BaseInputSelect,
    BaseInputMask,
  },
  props: {
    classifications: {
      type: Array,
      required: true,
    },
    isManager: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      eventBus: eventBus,
      isLoading: false,
      editableSeries: [],
      errors: {}
    }
  },
  computed: {
    ...mapGetters([
      'selectedClassificationId',
      'competitions',
      'eventTimesData',
    ]),
    series() {
      const selected = this.eventTimesData?.classifications?.find(clx => clx.external_id === this.selectedClassificationId);
      return selected?.series || [];
    },
    competition() {
      return this.competitions[this.$route.params.id]
    },
    seriesStartTime() {
      const selected = this.eventTimesData?.classifications?.find(clx => clx.external_id === this.selectedClassificationId);
      return selected?.start_event || null;
    },
    seriesEndTime() {
      const selected = this.eventTimesData?.classifications?.find(clx => clx.external_id === this.selectedClassificationId);
      return selected?.end_event || null;
    },
    selectedClassification() {
      return _.find(
        this.classifications,
        (classification) =>
          classification.id === this.selectedClassificationId
      )
    },
  },
  methods: {
    ...mapMutations({
      SET_SELECTED_CLASSIFICATION_ID,
    }),
    async submitSeries(seriesData, { reload = false } = {}) {
      this.isLoading = true;
      try {
        await apiAP.post(`/add_series.php`, {
          event: {
            external_id: this.competition.id,
            name: this.competition.name
          },
          classification: {
            external_id: this.selectedClassificationId,
            name: this.selectedClassification.namePl
          },
          series: seriesData,
        });

        if (reload) {
          await this.$store.dispatch(READ_EVENT_TIMES_DATA, this.competition.id)
        }
        if (this.editableSeries && this.editableSeries[seriesData.number]) {
          this.$set(this.errors, seriesData.number, false);
        }
      } catch (err) {
        console.error("Błąd podczas zapisu serii:", seriesData);
        this.$set(this.errors, seriesData.number, true)
      } finally {
        setTimeout(() => {
          this.isLoading = false;
        }, 2000);
      }
    },
    async setClassificationTime(key) {
      this.isLoading = true;
      try {
        await apiAP.post(`/add_series.php`, {
          event: {
            external_id: this.competition.id,
          },
          classification: {
            external_id: this.selectedClassificationId,
            name: this.selectedClassification.namePl,
            start_event: this.seriesStartTime,
            end_event: this.seriesEndTime,
            [key]: moment().format('YYYY-MM-DD HH:mm:ss')
          },
          series: {},
        });
        await this.$store.dispatch(READ_EVENT_TIMES_DATA, this.competition.id)
      }
      finally {
        this.isLoading = false
      }
    },
    async endEvent() {
      this.isLoading = true;
      try {
        await apiAP.post(`/add_series.php`, {
          event: {
            external_id: this.competition.id,
            end_event: moment().format('YYYY-MM-DD HH:mm:ss')
          },
          classifications: {},
          series: {},
        });
        await this.$store.dispatch(READ_EVENT_TIMES_DATA, this.competition.id)
      }
      finally {
        this.isLoading = false
      }
    },
    setFieldTime(idx, field, value) {
      let sync
      if (value) { sync = true }
      if (!value) { value = moment().format('YYYY-MM-DD HH:mm:ss') }
      this.$set(this.editableSeries[idx], field, value);
      if (sync) {
        const hasChanges = JSON.stringify(this.series.slice().sort((a, b) => a.number - b.number)) !==
          JSON.stringify(this.editableSeries.slice().sort((a, b) => a.number - b.number));
        if (hasChanges) {
          this.submitSeries(this.editableSeries[idx], { reload: true })
          // console.log('Zmiana w: ', idx, field, value);
        }
      }
    },
    addRow() {
      let newSeries
      if (this.series.length) {
        newSeries = { number: this.series.length + 1 }
      } else { newSeries = { number: 1 } }
      this.submitSeries(newSeries, { reload: true });
    },
  },

  watch: {
    series: {
      immediate: true,
      handler(newVal) {
        this.editableSeries = newVal.map(s => ({ ...s }));
      },
    },
  }
}
</script>

<style lang="scss" scoped>
@function contrast-color($color, $dark: #000, $light: #fff) {
  @if (lightness($color) > 50) {
    @return $dark;
  }

  @else {
    @return $light;
  }
}

.eventRow {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 5px;
  padding: 5px 10px;
  border: 2px solid $eventRowColor;
  background-color: lighten($color: $eventRowColor, $amount: 10%);
  color: contrast-color($eventRowColor);
  border-radius: 5px;

  &__name {
    display: flex;
    align-items: center;
    align-self: stretch;
    justify-content: center;
  }

  &__row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  &__time {
    justify-content: center;
    align-items: center;
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
  }
}

.series {
  margin: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;

  &__label {
    min-width: 100px;
    margin-left: 10px;
    align-items: stretch;
  }

  &__row {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: stretch;
    flex-wrap: wrap;
    gap: 8px
  }

  .row__content {
    background-color: $pale-grey;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    &--error {
      border: 2px solid $errorBorder;
      background-color: $errorBgc;
    }
  }



  &__cell {
    display: flex;
    flex: 1;
    justify-content: center;
    padding: 5px 10px;
    min-width: 300px;
  }

  .timeInput {
    flex: 1;
    margin-left: 5px;

    &--error {
      background-color: #ffc0cb;
    }
  }

  &__button {
    width: 100px;
    min-width: 80px;

    i {
      margin-left: 8px;
    }

    &--meta {
      background-color: $red-orange;
      color: $pale-grey;

      &:hover {
        background-color: darken($color: $red-orange, $amount: 16%);
      }
    }

    &--start {
      background-color: $green;
      color: $pale-grey;

      &:hover {
        background-color: darken($color: $green, $amount: 4%);
      }
    }

    &--add {
      background-color: $slate-two;
      min-width: 150px;
      color: $pale-grey;
      justify-content: space-between;
      padding: 10px 15px;

      &:hover {
        background-color: darken($color: $slate-two, $amount: 4%);
      }
    }
  }
}

.manager {
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999999;
  opacity: 1;
  display: flex;
  flex-direction: column;
  margin: 8px;
  padding: 0;
  border: 3px solid $charcoal-grey;
  background-color: $light-grey;

  &__header {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    width: 100%;
    background-color: $pale-grey;
    z-index: 5;

    h3 {
      flex: 1;
      text-align: center;
    }

    p {
      font-weight: bold;
      max-width: 130px;
    }
  }

  &__footer {
    background-color: $light-grey;
    padding: 5px;
  }

  &__body {
    background-color: $light-grey;
    overflow: auto;
  }

  &__classifications {
    flex: 1;
    margin-left: 8px;
    margin-right: 8px;
    max-width: 200px;
    background-color: var(--white);

    &--eventRow {
      flex: 1;
      margin-left: 8px;
      margin-right: 8px;
      // max-width: 200px;
      background-color: var(--white);

      .toggle,
      .fas,
      .fa-caret-down {
        color: #4a4a4a;
      }
    }
  }

  &__button {
    gap: 4px;
    min-width: 130px;
    max-width: 170px;

    &--endEvent {
      background-color: $red-orange;
      color: contrast-color($red-orange);

      &:hover {
        background-color: darken($color: $red-orange, $amount: 16%);
      }
    }

    &--startEvent {
      background-color: $green;
      color: contrast-color($green);

      &:hover {
        background-color: darken($color: $green, $amount: 6%);
      }
    }

    &--close {
      display: flex;
      gap: 8px;
      min-width: 130px;
      max-width: 200px;
      background-color: #546e7a;
      color: #fff;
      box-shadow: 0 8px 12px 0 rgba(0, 0, 0, .2);

      &:hover {
        background-color: darken($color: #546e7a, $amount: 4%);
      }

      @media (max-width: 768px) {
        display: none;
      }
    }

    &--close-ftr {
      display: flex;
      gap: 8px;
      background-color: #546e7a;
      color: #fff;
      box-shadow: 0 8px 12px 0 rgba(0, 0, 0, .2);

      &:hover {
        background-color: darken($color: #546e7a, $amount: 4%);
      }

      @media (min-width: 769px) {
        display: none;
      }
    }
  }
}
</style>